export default __webpack_public_path__ + "static/media/My project - 2023-05-23T172552.107 (2) (2).7f733be6.png";